import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { useCallback } from 'react';

import { AbstractDeviceRegistration } from './AbstractDeviceRegistration';

import { type DeviceVendor, type Journey, type VendorClientInput } from '../../.generated/types';
import { addVendorData } from '../server/actions';
import { determineApolloClient, determineAuthToken, determineJourney } from '../server/utils/utilities';

export interface DeviceRegistrationProps {
	authToken?: string;
	apolloClient?: ApolloClient<NormalizedCacheObject>;
	onRegistrationComplete?: (registrationId: string, vendors: DeviceVendor[]) => void;
	journey?: Journey;
}

export function DeviceRegistration(props: DeviceRegistrationProps) {
	const authToken = determineAuthToken(props);
	const client = determineApolloClient(props, authToken);
	const journey = determineJourney(props);

	const onVendorsComplete = useCallback(
		(registrationId: string, vendorClientInputs: VendorClientInput[]) => {
			if (vendorClientInputs.length > 0) {
				addVendorData({ authToken, client, registrationId, vendorClientInputs });
			}
		},
		[authToken, client],
	);

	return (
		<AbstractDeviceRegistration
			authToken={authToken}
			apolloClient={client}
			journey={journey}
			onRegistrationComplete={props.onRegistrationComplete}
			onVendorsComplete={onVendorsComplete}
		/>
	);
}
